import { put, takeLatest } from 'redux-saga/effects';

import * as LoginActions from './actions';

function * notifyCommitComplete (action) {
  yield put({
    type: LoginActions.SIGNUP_COMMIT_COMPLETE
  });
}

function * loginSaga () {
  yield takeLatest(LoginActions.SIGNUP_COMMITTED, notifyCommitComplete);
}

export default loginSaga;
